import { useFindAllLicensesQuery } from '../../api/api-hooks';
import { DataGrid, GridColDef, GridSelectionModel } from '@mui/x-data-grid';
import { CircularProgress } from '@mui/material';
import React from 'react';
import { Item } from '../../utils/sharedTypes';
import { Order, License } from '../../api/api-generated';
import { LicenseFilter } from './licensesTypes';
import { filterLicense } from './licensesUtils';

interface Props {
  setSelectedLicenses: React.Dispatch<React.SetStateAction<Item[]>>;
  extraFilters: {
    order?: Order;
    excludeOrder?: boolean;
  };
  filters?: LicenseFilter;
}

const LicensesTable = ({
  setSelectedLicenses,
  extraFilters,
  filters,
}: Props) => {
  const { data: allLicenses } = useFindAllLicensesQuery({});
  if (allLicenses === undefined) return <CircularProgress></CircularProgress>;
  const filteredLicenses = allLicenses.filter((license) => {
    if (extraFilters.order) {
      if (license.orderId === extraFilters.order.id) {
        if (extraFilters.excludeOrder) return false;
        else return true;
      } else {
        if (extraFilters.excludeOrder) return true;
        else return false;
      }
    }
    return true;
  });
  // Define data for display in DataGrid
  const columns: GridColDef[] = [
    { field: 'order', headerName: 'Order', width: 180 },
    { field: 'software', headerName: 'Software', width: 180 },
    { field: 'hardware', headerName: 'Hardware', width: 180 },
    { field: 'module', headerName: 'Module', width: 180 },
  ];
  const rows = filteredLicenses
    .filter((item: License) => filterLicense(item, filters))
    .map((item: License) => ({
      ...item,
      order: item.order ? item.order.purchaseOrderName : 'None',
      software: item.software.type,
      hardware: item.hardware.serial,
      module: item.module ? item.module.moduleName : 'None',
    }));
  const handleTableSelection = (model: GridSelectionModel) => {
    setSelectedLicenses(
      filteredLicenses.filter((license) => model.includes(license.id))
    );
  };
  return (
    <div style={{ paddingBottom: '1rem', width: '100%' }}>
      <DataGrid
        rows={rows}
        columns={columns}
        pageSize={100}
        checkboxSelection
        disableSelectionOnClick
        autoHeight
        disableColumnMenu={true}
        onSelectionModelChange={handleTableSelection}
      />
    </div>
  );
};

export default LicensesTable;
